import { RouteView,PageView } from '../layouts'
export const mall =   {
    path: '/mall',
    name: 'BaseForm',
    component: PageView,
    meta: { title: '积分商城', icon: 'shop',isMenuShow:true,permission:'mall'},
    children:[
        {
            path: '/mall/goods',
            name: 'BaseForm',
            component: PageView,
            redirect:'/mall/goods/list',
            meta: { title: '商品列表', keepAlive: false ,isMenuShow:true,permission:'mall:goods'},
            children:[
                {
                    path: '/mall/goods/list',
                    name: 'BaseForm',
                    component: () => import('../views/mall/goodsList.vue'),
                    meta: { title: '商品列表', keepAlive: false, isMenuShow:true,permission:'mall:goods'},
                },
                {
                    path: '/mall/goods/detail',
                    name: 'BaseForm',
                    component: () => import('../views/mall/goodsDetail.vue'),
                    meta: { title: '商品详情', keepAlive: false, isMenuShow:false,permission:'mall:goods:detail'}
                },
                {
                    path: '/mall/goods/update',
                    name: 'BaseForm',
                    component: () => import('../views/mall/editGoods.vue'),
                    meta: { title: '编辑商品', keepAlive: false, isMenuShow:false,permission:'mall:goods:edit'}
                },
                {
                    path: '/mall/goods/addGoods',
                    name: 'BaseForm',
                    component: () => import('../views/mall/addGoods.vue'),
                    meta: { title: '添加商品', keepAlive: false, isMenuShow:false,permission:'mall:goods:add'}
                },
            ]
        },

        {
            path: '/mall/catalogue',
            name: 'BaseForm',
            component: PageView,
            redirect:'/mall/catalogue/list',
            meta: { title: '商品分类', keepAlive: false ,isMenuShow:true,permission:'mall:sort'},
            children:[
                {
                    path: '/mall/catalogue/list',
                    name: 'BaseForm',
                    component: () => import('../views/mall/catalogueList.vue'),
                    meta: { title: '商品分类列表', keepAlive: false, isMenuShow:true,permission:'mall:sort'},
                },
                {
                    path: '/mall/catalogue/detail',
                    name: 'BaseForm',
                    component: () => import('../views/mall/catalogueDetail.vue'),
                    meta: { title: '商品分类详情', keepAlive: false, isMenuShow:false,permission:'mall:sort'}
                },
                {
                    path: '/mall/catalogue/add',
                    name: 'BaseForm',
                    component: () => import('../views/mall/addCatalogue.vue'),
                    meta: { title: '添加商品分类', keepAlive: false, isMenuShow:false,permission:'mall:sort'}
                },
                {
                    path: '/mall/catalogue/update',
                    name: 'BaseForm',
                    component: () => import('../views/mall/updateCatalogue.vue'),
                    meta: { title: '编辑商品分类', keepAlive: false, isMenuShow:false,permission:'mall:sort:edit'}
                },
            ]
        },

        {
            path: '/mall/homeGoods',
            name: 'BaseForm',
            component: PageView,
            redirect:'/mall/homeGoods/list',
            meta: { title: '商品分类管理', keepAlive: false ,isMenuShow:true,permission:'mall:home'},
            children:[
                {
                    path: '/mall/homeGoods/list',
                    name: 'BaseForm',
                    component: () => import('../views/mall/homeGoodsList.vue'),
                    meta: { title: '商品分类管理', keepAlive: false, isMenuShow:true,permission:'mall:home'},
                },
                {
                    path: '/mall/homeGoods/addHomeGoods',
                    name: 'BaseForm',
                    component: () => import('../views/mall/addHomeGoods'),
                    meta: { title: '新增商品', keepAlive: false, isMenuShow:true,permission:'mall:home:add'},
                },
            ]
        },
        // 原商城广告管理（轮播图） 删除
        // {
        //     path: '/mall/imageCarousel',
        //     name: 'BaseForm',
        //     component: PageView,
        //     redirect:'/mall/imageCarousel/list',
        //     meta: { title: '商城广告管理（轮播图）', keepAlive: false ,isMenuShow:true,permission:'mall:adv'},
        //     children:[
        //         {
        //             path: '/mall/imageCarousel/list',
        //             name: 'BaseForm',
        //             component: () => import('../views/mall/imageCarouselList.vue'),
        //             meta: { title: '广告列表', keepAlive: false, isMenuShow:true,permission:'mall:adv'},
        //         },
        //         {
        //             path: '/mall/imageCarousel/detail',
        //             name: 'BaseForm',
        //             component: () => import('../views/mall/imageCarouselDetail.vue'),
        //             meta: { title: '广告编辑', keepAlive: false, isMenuShow:false,permission:'mall:adv:edit'}
        //         },
        //         {
        //             path: '/mall/imageCarousel/addImageCarousel',
        //             name: 'BaseForm',
        //             component: () => import('../views/mall/addImageCarousel.vue'),
        //             meta: { title: '添加广告', keepAlive: false, isMenuShow:false,permission:'mall:adv:add'}
        //         },
        //         // {
        //         //     path: '/mall/imageCarousel/update',
        //         //     name: 'BaseForm',
        //         //     component: () => import('@/views/mall/updateImageCarousel.vue'),
        //         //     meta: { title: '编辑广告', keepAlive: false, isMenuShow:false}
        //         // },
        //     ]
        // },
        {
            path: '/mall/orders',
            name: 'BaseForm',
            component: PageView,
            redirect:'/mall/orders/list',
            meta: { title: '商城订单管理', keepAlive: false ,isMenuShow:true,permission:'mall:order'},
            children:[
                {
                    path: '/mall/orders/list',
                    name: 'BaseForm',
                    component: () => import('@/views/mall/orders.vue'),
                    meta: { title: '订单列表', keepAlive: false, isMenuShow:true,permission:'mall:order'},
                },
                {
                    path: '/mall/orders/detail',
                    name: 'BaseForm',
                    component: () => import('@/views/mall/ordersDetail.vue'),
                    meta: { title: '订单详情', keepAlive: false, isMenuShow:false,permission:'mall:order:real'}
                },
                {
                    path: '/mall/ordersCoupon/detail',
                    name: 'BaseForm',
                    component: () => import('@/views/mall/ordersCouponDetail.vue'),
                    meta: { title: '卡券订单详情', keepAlive: false, isMenuShow:false,permission:'mall:order:coupon'}
                },
            ]
        },
        {
            path: '/mall/integral',
            name: 'Integral',
            component: PageView,
            redirect:'/mall/orders/integral',
            meta: { title: '积分商城入口配置', keepAlive: false ,isMenuShow:true,permission:'mall:integral'},
            children: [
                {
                    path: '/mall/orders/integral',
                    name: 'Integral',
                    component: () => import('@/views/mall/integral.vue'),
                    meta: { title: 'APP积分商城入口配置', keepAlive: false, isMenuShow:true,permission:'mall:integral'},
                }
            ]
        },
    ]
}
